import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { useFiltersStateStore } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import { removePropertyFilters } from 'framework-listing-lib/utils/filters';
import useExpandCollapseRow from 'framework-listing-lib/hooks/useExpandCollapseRow';

/**
 * Returns a stable callback that removes all filter operators for a given
 * property name from the current filter state.
 *
 * Useful when a component needs to clear a specific filter condition without
 * resetting the rest of the applied filters.
 */
export default function useRemovePropertyFilter() {
  "use memo";

  const $ = _c(3);
  const onSetFilters = useFiltersStateStore(_temp);
  const {
    collapseAll
  } = useExpandCollapseRow();
  let t0;
  if ($[0] !== collapseAll || $[1] !== onSetFilters) {
    t0 = propertyName => {
      onSetFilters(prevFilters => Object.assign({}, prevFilters, {
        filterGroups: removePropertyFilters(prevFilters.filterGroups, propertyName)
      }));
      collapseAll();
    };
    $[0] = collapseAll;
    $[1] = onSetFilters;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp(state) {
  return state.setFilters;
}